/**
 * Password Generation Command
 * Generate secure random passwords
 */
import { Command } from 'commander';
import { UtilsService } from '../../services/utils.service.js';

async function handlePasswordGeneration(options: {
    length: number;
    lowercase: boolean;
    uppercase: boolean;
    digits: boolean;
    symbols: boolean;
    symbolChars?: string;
    count: number;
}): Promise<void> {
    const service = new UtilsService();

    try {
        const passwords: string[] = [];

        for (let i = 0; i < options.count; i++) {
            const password = service.generatePassword({
                length: options.length,
                lowercase: options.lowercase,
                uppercase: options.uppercase,
                digits: options.digits,
                symbols: options.symbols,
                symbolChars: options.symbolChars,
            });
            passwords.push(password);
        }

        console.log('🔐 Generated Password(s):');
        console.log('────────────────────────────────────────\n');

        passwords.forEach((password, index) => {
            if (options.count > 1) {
                console.log(`   ${index + 1}. ${password}`);
            } else {
                console.log(`   ${password}`);
            }
        });

        console.log();
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createPasswordCommand(): Command {
    const cmd = new Command('password')
        .description('Generate secure random password')
        .option('-l, --length <number>', 'Password length', '16')
        .option('--no-lowercase', 'Exclude lowercase letters')
        .option('--no-uppercase', 'Exclude uppercase letters')
        .option('--no-digits', 'Exclude digits')
        .option('--no-symbols', 'Exclude symbols')
        .option('--symbol-chars <chars>', 'Custom symbol characters')
        .option('-c, --count <number>', 'Number of passwords to generate', '1')
        .addHelpText('after', `
Examples:
  $ jai1 utils password
  $ jai1 utils password --length 24
  $ jai1 utils password --no-symbols
  $ jai1 utils password --count 5
  $ jai1 utils password -l 32 --no-digits
`)
        .action(async (options) => {
            await handlePasswordGeneration({
                ...options,
                length: parseInt(options.length, 10),
                count: parseInt(options.count, 10),
            });
        });

    return cmd;
}
